import React from 'react';
import { useLocation } from 'react-router-dom';

import { ApolloError } from '@apollo/client';

import { ModifierGroup, useMenuItemDetailsQuery } from 'src/apollo/onlineOrdering';
import { Channel } from 'src/public/js/siteUtilities';

import { useRestaurant } from 'shared/components/common/restaurant_context/RestaurantContext';
import NoMatch404 from 'shared/components/no_match_404/NoMatch404';

import { MenuItem } from 'public/components/default_template/menu_section/MenuSection';
import OrderPageWrapper, { OrderPageContentProps } from 'public/components/default_template/online_ordering/pages/OrderPageWrapper';

import { ProductDisplay } from './ProductDisplay';

type LocationState = {
  menuItem?: MenuItem
}

const ProductDisplayPageContent = ({ itemGuid, itemGroupGuid }: OrderPageContentProps) => {
  const { restaurant: siteRestaurant, selectedLocation } = useRestaurant();
  const channelGuid = selectedLocation?.ecommMenuChannelGuid || undefined;
  const { state } = useLocation<LocationState>();

  const { data, error, loading: menuItemDetailsLoading } = useMenuItemDetailsQuery({
    variables: {
      input: {
        itemGuid: itemGuid || '',
        itemGroupGuid: itemGroupGuid || '',
        restaurantGuid: selectedLocation?.externalId || '',
        channelGuid: channelGuid
      },
      nestingLevel: 10
    },
    skip: false
  });

  // massage menuItemDetails into the MenuItem type
  const menuItem: MenuItem | undefined = data?.menuItemDetails ?
    { ...data?.menuItemDetails, guid: itemGuid || null, itemGroupGuid: itemGroupGuid || '' }
    : state?.menuItem;
  const loading = !menuItem && menuItemDetailsLoading;

  return (
    <div className="pageContent">
      <div className="paddedContentWrapper">
        {error && itemNotFound(error) && <NoMatch404 meta={siteRestaurant?.meta} siteTheme={siteRestaurant?.theme} /> }
        {!loading && !error && menuItem && <ProductDisplay menuItem={menuItem} modifierGroups={data?.menuItemDetails?.modifierGroups as ModifierGroup[] || []} />}
      </div>
    </div>
  );
};

const itemNotFound = (error: ApolloError | undefined) => error?.graphQLErrors?.some((err: any) => err?.extensions?.code === 'MENU_ITEM_NOT_FOUND');

const ProductDisplayPage = () => {
  return (
    <OrderPageWrapper channel={Channel.ECOMM}>
      {props =>
        <ProductDisplayPageContent
          {...props} />}
    </OrderPageWrapper>);
};
export default React.memo(ProductDisplayPage);
